import { EXPRESS_URL } from "../utils/Macros";

export const verify = async (payload: any): Promise<any> => {
    const res = await fetch(`${EXPRESS_URL}recaptcha`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
    if(!res.ok) {
        console.error("Errore nella verifica del recaptcha");
        return false;
    }
    return true;
};